<template>
  <div v-if="!isMobile()">
    <div class="section section-trailer" id="trailer-section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 data-aos="fade-up" class="title deco1">
              {{ $t(`About Game`) }}
            </h3>
            <div v-if="$i18n.locale == 'ch-zn'" class="video-container">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://player.youku.com/embed/XNDYyOTc1OTM4OA=="
              ></iframe>
            </div>
            <div v-else class="video-container">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/a1CWQgom4P8"
              ></iframe>
            </div>
            <h5
              data-aos="fade-right"
              class="description"
              style="padding-top: 30px"
            >
              {{ $t(`official trailer desc`) }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div data-aos="fade-right" data-aos-offset="-500" class="col-lg-4">
            <div
              class="col-lg-12 box-blockchain"
              style="padding: 5px 5px 0px; height: 440px;"
            >
              <img v-lazy="'/img/img_game_01.png'" width="100%" />
              <h5 class="blockchain-title" style="margin: -42px 10% 0; height: 40px;">
                {{ $t(`game title 1`) }}
              </h5>
              <h5
                class="blockchain-desc"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 1`) }}
              </h5>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-offset="-500" class="col-lg-4">
            <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;  height: 440px;">
              <img v-lazy="'/img/img_game_02.png'" width="100%" />
              <div style="width: 90%; margin: auto;">
              <h5 class="blockchain-title" style="margin: -52px 10% 0; height: 50px;">
                {{ $t(`game title 2`) }}
              </h5>
              </div>
              <h5
                class="blockchain-desc"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 2`) }}
              </h5>
            </div>
          </div>
          <div data-aos="fade-left" data-aos-offset="-500" class="col-lg-4">
            <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;  height: 440px;">
              <img v-lazy="'/img/img_game_03.png'" width="100%" />
              <h5 class="blockchain-title" style="margin: -42px 10% 0; height: 40px;">
                {{ $t(`game title 3`) }}
              </h5>
              <h5
                class="blockchain-desc"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 3`) }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="section-m section-trailer" id="trailer-section">
      <div class="container" style="width: 85%;">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 class="title-m deco1">
              {{ $t(`About Game`) }}
            </h3>
            <div v-if="$i18n.locale == 'ch-zn'" class="video-container">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://player.youku.com/embed/XNDYyOTc1OTM4OA=="
              ></iframe>
            </div>
            <div v-else class="video-container">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/a1CWQgom4P8"
              ></iframe>
            </div>
            <h5
              class="description-m"
              style="padding-top: 30px"
            >
              {{ $t(`official trailer desc`) }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4" style="margin-top: 10px;">
            <div
              class="col-lg-12 box-blockchain"
              style="padding: 5px 5px 0px; height: 400px;"
            >
              <img v-lazy="'/img/img_game_01.png'" width="100%" />
              <h5 class="blockchain-title-m" style="margin: -35px 10% 0; height: 40px;">
                {{ $t(`game title 1`) }}
              </h5>
              <h5
                class="blockchain-desc-m"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 1`) }}
              </h5>
            </div>
          </div>
          <div class="col-lg-4" style="margin-top: 10px;">
            <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;  height: 400px;">
              <img v-lazy="'/img/img_game_02.png'" width="100%" />
              <div style="width: 95%; margin: auto;">
              <h5 class="blockchain-title-m" style="margin: -40px 10% 0; height: 45px;">
                {{ $t(`game title 2`) }}
              </h5>
              </div>
              <h5
                class="blockchain-desc-m"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 2`) }}
              </h5>
            </div>
          </div>
          <div class="col-lg-4" style="margin-top: 10px;">
            <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;  height: 400px;">
              <img v-lazy="'/img/img_game_03.png'" width="100%" />
              <h5 class="blockchain-title-m" style="margin: -35px 10% 0; height: 40px;">
                {{ $t(`game title 3`) }}
              </h5>
              <h5
                class="blockchain-desc-m"
                style="margin: 30px 20px 0px; height: 150px"
              >
                {{ $t(`game desc 3`) }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style></style>
